<!--
 * IMPORTANT:
 * This file is used in both vue2 and vue3 application
 * Make sure to check both versions while making changes to this file
 * Don't use store or vue syntax in this file
 * for any clarification contact Leela
 -->
<template>
  <div v-if="modalShowPopUp" id="disasterModalPopUp" class="modal">
    <div class="modal-content position-relative">
      <div class="text-right mb-3">
        <a class="close-icon no-hover font-weight-bold cursor-pointer"  @click.prevent="closeModal()">
          <em class="primaryicon-times" />
        </a>
      </div>

      <div v-if="disasterMessagesData.length" class="text-center mb-3">
        <div v-for="(item, index) in disasterMessagesData" :key="index"
        class="pb-30">
          <div v-html="item.popupMessage"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getDisasterMessages } from "../disasterBanner/DisasterService.js";
export default {
  data() {
    return {
      modalShowPopUp: false,
      disasterModalSession: true,
      disasterMessagesData: [],
      enableDisasterMessage: window.enableDisasterMessage,
    };
  },
  watch: {},
  mounted() {
    if (sessionStorage.getItem("disasterModal") === null && this.enableDisasterMessage) {
      this.getDisasterMessagesData();
    }
  },
  methods: {
    async getDisasterMessagesData() {
      let isIframe = window.location !== window.parent.location;
      if(isIframe) return;
      try {
        const responseData = await getDisasterMessages();
        if (responseData && responseData.length) {
           this.disasterMessagesData = responseData.filter(
            (msg) => msg.popupMessage && msg.popupMessage.trim() !== "null"
          );
          if (this.disasterMessagesData.length) {
            this.modalShowPopUp = true;
          } else {
            this.modalShowPopUp = false;
          }
        }
      } catch (error) {
        console.error("Error fetching disaster messages:", error);
      }
    },
    closeModal() {
      this.modalShowPopUp = false;
      sessionStorage.setItem("disasterModal", "hide");
    },
  },
};
</script>
<style scoped>
.pb-30 {
  padding-bottom: 30px;
}
#disasterModalPopUp.modal {
  display: flex;
  position: fixed;
  z-index: 99;
  padding-top: 100px;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.9);
}
/* Modal Content */
#disasterModalPopUp .modal-content {
  background-color: #fff;
  margin: auto;
  padding: 20px;
  border: 1px solid #888;
  width: 85%;
}
#disasterModalPopUp .close-icon {
  border-radius: 50%;
  background-color: #e6e6e6;
  color: #8b8585 !important;
  width: 30px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  font-size: 12px;
}
</style>
